module.exports = __webpack_public_path__ + "static/3-create-environment-09fb15ef2acaf2a48ab7eb8ec6a6e712.png";